import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import {
    selectPreferences,
    selectIsMobilePDPImageZoomed,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { getSelectedProductVideos } from 'yoda-site-components/lib/selectors/ProductImageSelector';
import UrgencyPdpSold from 'yoda-core-components/lib/assets/svg/UrgencyPdpSold.svg';
import UrgencyPdpQuickAdd from 'yoda-core-components/lib/assets/svg/UrgencyPdpQuickadd.svg';
import UrgencyPdpView from 'yoda-core-components/lib/assets/svg/UrgencyPdpView.svg';
import { getVirtualTryOnData } from '../../selectors/VirtualTryOnSelector';
import * as styles from './UrgencyMessaging.css';
import getUrgencyStatementsAction from '../../actions/UrgencyMessagingAction';
import UrgencyMessageBlock from './UrgencyMessageBlock';

const cx = classNames.bind(styles);

export class UrgencyMessaging extends Component {
    static defaultProps = {
        productDetails: {},
        actions: {},
        urgencyStatements: {},
        deviceType: {},
        preferences: {},
        productVideos: [],
        virtualTryOn: {},
        isMobilePDPImageZoomed: false,
        enableZoomOnProductImage: false,
    };

    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        actions: PropTypes.objectOf(PropTypes.func),
        urgencyStatements: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        preferences: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productVideos: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        virtualTryOn: PropTypes.object,
        isMobilePDPImageZoomed: PropTypes.bool,
        enableZoomOnProductImage: PropTypes.bool,
    };

    componentDidMount() {
        const {
            productDetails: { id = '' },
            preferences,
        } = this.props;
        this.props.actions.getUrgencyStatementsAction({
            ppid: id,
            apiURL: preferences.URGENCY_API_URL,
        });
    }

    render() {
        const {
            urgencyStatements,
            deviceType,
            productVideos,
            virtualTryOn,
            isMobilePDPImageZoomed,
            enableZoomOnProductImage,
        } = this.props;
        const vtoToggleEnabled = get(virtualTryOn, 'data.enabled');
        const shouldAnimate = typeof vtoToggleEnabled === 'undefined';
        let soldMessage = '';
        let viewMessage = '';
        let cartAddMessage = '';
        let messagesArray = [];
        let UrgencyMessages;
        const soldIconName = 'urgency-pdp-sold';
        const soldIconComponent = <UrgencyPdpSold />;
        const cartAddIconName = 'urgency-pdp-quickadd';

        const cartAddIconComponent = <UrgencyPdpQuickAdd />;

        const viewIconName = 'urgency-pdp-view';
        const viewIconComponent = <UrgencyPdpView />;
        const styleUrgencyMsgContainer = [
            'urgencyMsgContainer',
            'containerBottom',
            'urgencyMsgPositionBottom',
        ];
        productVideos &&
            productVideos.length &&
            styleUrgencyMsgContainer.push('urgencyMsgPositionBottomVideoLabels');

        if (
            urgencyStatements.soldMessage &&
            urgencyStatements.viewMessage &&
            urgencyStatements.addToCartMessage
        ) {
            soldMessage = urgencyStatements.soldMessage;
            cartAddMessage = urgencyStatements.addToCartMessage;
            messagesArray = [
                {
                    message: soldMessage,
                    type: 'sold',
                    iconName: soldIconName,
                    iconComponent: soldIconComponent,
                },
                {
                    message: cartAddMessage,
                    type: 'cartAdd',
                    iconName: cartAddIconName,
                    iconComponent: cartAddIconComponent,
                },
            ];
        } else {
            if (urgencyStatements.soldMessage) {
                soldMessage = urgencyStatements.soldMessage;
                messagesArray.push({
                    message: soldMessage,
                    type: 'sold',
                    iconName: soldIconName,
                    iconComponent: soldIconComponent,
                });
            }
            if (urgencyStatements.addToCartMessage) {
                cartAddMessage = urgencyStatements.addToCartMessage;
                messagesArray.push({
                    message: cartAddMessage,
                    type: 'cartAdd',
                    iconName: cartAddIconName,
                    iconComponent: cartAddIconComponent,
                });
            }
            if (urgencyStatements.viewMessage) {
                viewMessage = urgencyStatements.viewMessage;
                messagesArray.push({
                    message: viewMessage,
                    type: 'view',
                    iconName: viewIconName,
                    iconComponent: viewIconComponent,
                });
            }
        }

        if (messagesArray.length) {
            UrgencyMessages = messagesArray.map((urgencyMessage, index) => {
                const delaytime = isMobilePDPImageZoomed ? 1 : 2500;
                const delay = (index + 1) * delaytime;
                let animationDelay = delay;
                if (index === 1) {
                    animationDelay = (index + 1) * 1000;
                }
                return (
                    <UrgencyMessageBlock
                        deviceType={deviceType}
                        urgencyMessage={urgencyMessage}
                        delay={delay}
                        animationDelay={animationDelay}
                        shouldAnimate={shouldAnimate}
                        enableZoomOnProductImage={enableZoomOnProductImage}
                    />
                );
            });
        }

        return urgencyStatements &&
            urgencyStatements.signals &&
            urgencyStatements.signals.length ? (
            <div
                className={cx(styleUrgencyMsgContainer)}
                data-automation-id="urgencyMessageContainer"
                id="urgencyhovereffect"
            >
                {' '}
                {UrgencyMessages}{' '}
            </div>
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    urgencyStatements: state.urgencyStatements || {},
    deviceType: state.context ? state.context.deviceType : {},
    preferences: selectPreferences(state),
    enableZoomOnProductImage: get(state, 'context.featureFlags.enableZoomOnProductImage', false),
    productVideos: getSelectedProductVideos(false)(state),
    virtualTryOn: getVirtualTryOnData(state),
    productDetails: state.productDetails,
    isMobilePDPImageZoomed: selectIsMobilePDPImageZoomed(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ getUrgencyStatementsAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UrgencyMessaging);
